export default "__VITE_ASSET__C_WYJ9$2__"